import React, { useState, useEffect } from 'react';
import { Badge, Table } from 'flowbite-react';
import { UserAvailabilityInput } from 'types';
import moment from 'moment';

type Props = {
	availabilities: UserAvailabilityInput[];
};

const AvailabilitiesByDateTable = ({ availabilities }: Props) => {
	const [availabilitiesByDate, setAvailabilitiesByDate] = useState<Record<string, UserAvailabilityInput[]>>({});

	useEffect(() => {
		if (availabilities) {
			let byDateAvailabilities = availabilities
				.sort((a, b) => moment(a.startTime).valueOf() - moment(b.startTime).valueOf())
				?.reduce((acc: Record<string, UserAvailabilityInput[]>, crr) => {
					let date = moment(crr.startTime).format('DD-MM-YYYY');

					if (acc[date]) {
						acc[date].push(crr);
					} else {
						acc[date] = [crr];
					}

					return acc;
				}, {});
			setAvailabilitiesByDate(byDateAvailabilities);
		}
	}, [availabilities]);

	if (Object.keys(availabilities).length === 0) {
		return <div>No Slots Selected</div>;
	}

	return (
		<div className="grid gap-2">
			<div className="flex flex-wrap gap-2">
				<Badge color="failure">Booked Slots</Badge>
				<Badge color="success">Available</Badge>
				<Badge color="warning">Not Available</Badge>
			</div>

			<Table>
				<Table.Head>
					<Table.HeadCell>Date</Table.HeadCell>
					<Table.HeadCell>Slots</Table.HeadCell>
				</Table.Head>
				<Table.Body className="divide-y">
					{Object.keys(availabilitiesByDate).map(availabilitiesDate => (
						<Table.Row key={availabilitiesDate}>
							<Table.Cell>
								<div className="w-32 text-base">{availabilitiesDate}</div>
							</Table.Cell>
							<Table.Cell>
								<div className="flex flex-wrap gap-2 ">
									{availabilitiesByDate[availabilitiesDate]
										.sort((a, b) => a.duration - b.duration)
										.map((availabiliy: UserAvailabilityInput, index) => (
											<Badge key={index} className="w-36" color={availabiliy.isBooked ? 'failure' : 'success'}>
												<div>
													<div className="flex w-full items-center justify-center">{availabiliy.duration} Minutes</div>
													<div>
														{`${moment(availabiliy.startTime).format('hh:mm a')} - ${moment(availabiliy.endTime).format(
															'hh:mm a',
														)}`}
													</div>
												</div>
											</Badge>
										))}
								</div>
							</Table.Cell>
						</Table.Row>
					))}
				</Table.Body>
			</Table>
		</div>
	);
};

export default AvailabilitiesByDateTable;
